export default __webpack_public_path__ + "static/media/SC_lg.bfecd993.png";